import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'ngx-toastr';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-toast',
  imports: [MatIcon],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent extends Toast {
  protected getToastIconName(): string {
    if (this.toastPackage.toastType === 'toast-info') {
      return 'info';
    } else if (this.toastPackage.toastType === 'toast-error') {
      return 'error';
    } else if (this.toastPackage.toastType === 'toast-success') {
      return 'check-circle';
    } else {
      return 'check-circle';
    }
  }
}
